export const DIALOG_Z_INDEX = {
  STANDARD: 5000
} as const
